import React from "react";
import Typewriter from "typewriter-effect";

const HeroSection = () => {
  
  const handleScroll = (id) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const styles = {
    heroContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "calc(100vh - 120px)",
      marginTop: "50px",
      padding: "60px 80px",
      background: "radial-gradient(circle at center, rgba(127, 0, 255, 0.1), rgba(0, 0, 0, 0.6))",
      backdropFilter: "blur(8px)",
      borderRadius: "16px",
      border: "1px solid rgba(255, 255, 255, 0.08)",
      boxShadow: "0 0 40px rgba(127, 0, 255, 0.5)",
      color: "#ffffff",
      fontFamily: "'Orbitron', sans-serif",
      boxSizing: "border-box",
    },

    leftSection: {
      flex: 1,
      paddingRight: "50px",
    },

    nameHeading: {
      fontSize: "48px",
      fontWeight: "bold",
      marginBottom: "10px",
      color: "#e0b3ff",
      textShadow: "0 0 5px #fff, 0 0 10px #7f00ff",
    },

    typewriterText: {
      fontSize: "20px",
      fontWeight: "bold",
      color: "#00ffff",
      marginBottom: "20px",
      textShadow: "0 0 3px #00ffff, 0 0 6px #00ffff",
    },

    paragraph: {
      fontSize: "17px",
      lineHeight: "1.8",
      color: "#d1d1ff",
      fontFamily: "'Share Tech Mono', monospace",
      marginBottom: "40px",
    },

    buttonGroup: {
      display: "flex",
      gap: "20px",
    },

    button: {
      padding: "12px 24px",
      fontSize: "16px",
      fontWeight: "bold",
      borderRadius: "30px",
      border: "none",
      cursor: "pointer",
      background: "#7f00ff",
      color: "#ffffff",
      boxShadow: "0 0 10px #7f00ff",
      transition: "transform 0.2s ease-in-out",
    },

    rightSection: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    profileImage: {
      width: "240px",
      height: "240px",
      borderRadius: "50%",
      border: "3px solid #7f00ff",
      boxShadow: "0 0 30px rgba(127, 0, 255, 0.7)",
      transition: "transform 0.3s ease-in-out",
    },
  };

  return (
    <div style={styles.heroContainer}>
      <div style={styles.leftSection}>
        <h1 style={styles.nameHeading}>Navya Malhotra</h1>
        <div style={styles.typewriterText}>
          <Typewriter
            options={{
              strings: ["Web Developer", "Cloud Enthusiast", "ML Explorer"],
              autoStart: true,
              loop: true,
            }}
          />
        </div>
        <p style={styles.paragraph}>
         I’m a final year Computer Science student who loves building meaningful web applications, 
         exploring the cloud, and diving into machine learning. I thrive on learning by doing and enjoy 
         sharing what I discover along the way. Each project is a space for me to explore, grow, 
         and challenge myself—and that's what keeps me coming back, one idea at a time.
        </p>
        <div style={styles.buttonGroup}>
          <button
            style={styles.button}
            onClick={() => handleScroll('venus')}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          >
            View My Work
          </button>
          <button
            style={styles.button}
             onClick={() => handleScroll('jupiter')}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          >
            Contact Me
          </button>
        </div>
      </div>

      <div style={styles.rightSection}>
        <img
          src={require("../images/img.png")}
          alt="Profile"
          style={styles.profileImage}
        />
      </div>
    </div>
  );
};

export default HeroSection;
